// extracted by mini-css-extract-plugin
export default {"link":"BzTPNT","image":"OcGXIS","root":"LKjYWx"};